<template>
    <page-heading page-title="Dostawa zakupów do domu" buttons="{buttons_with_href_obj}"/>


    <div class="max-w-7xl m-auto py-10">

        <div class="max-w-5xl m-auto pt-4 px-4">
            <p class="text-md text-gray-800 text-center"><b>Supermarket online "u Chowańca"</b> dostarcza zakupy
                spożywcze na terenie powiatów: <b>bielskiego, żywieckiego i
                    cieszyńskiego,</b> za pośrednictwem wyspecjalizowanych, lokalnych dostawców. </p>

            <div class="flex justify-center my-16">
                <a href="https://uchowanca.pl/dostawaZeroFbEs" target="_blank">
                    <button type="button"
                            class="inline-flex items-center rounded-full border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                        Kupuj online
                    </button>
                </a>
                <a href="#promoCodesBox">
                    <button type="button"
                            class="ml-2 inline-flex items-center rounded-full border border-transparent bg-yellow-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2">
                        Kody rabatowe
                    </button>
                </a>

            </div>
        </div>

        <div>
            <a href="https://uchowanca.pl/dostawaZeroFbEs" target="_blank">
                <img class="w-screen my-20 rounded" src="/img/delivery-products-top.jpg" alt="delivery"/>
            </a>
        </div>

        <h1 id="promoCodesBox" class="text-2xl bold text-center">Kody rabatowe</h1>

        <div class="my-12">
            <div class="overflow-hidden bg-white shadow sm:rounded-md">
                <ul role="list" class="divide-y divide-gray-200">
                    <li v-for="position in positions" :key="position.id">
                        <div @click="copyCode(position.code)" title="Skopiuj kod" class="cursor-pointer block hover:bg-gray-50">
                            <div class="px-4 py-4 sm:px-6">
                                <div class="flex items-center justify-between">
                                    <p class="truncate text-xl text-indigo-600 font-extrabold">{{ position.code }}</p>
                                    <div class="ml-2 flex flex-shrink-0">
                                        <p class="cursor-pointer inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                                            {{ position.active }}</p>
                                    </div>
                                </div>
                                <div class="mt-2 sm:flex sm:justify-between">
                                    <div class="sm:flex">
                                        <p class="flex items-center text-sm text-gray-500 font-bold">
                                            {{ position.name }}
                                        </p>
                                    </div>
                                    <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                                        <p>
                                            Ważny od:
                                            {{ ' ' }}
                                            <time :datetime="position.beginsAt">{{ position.beginsAt }}</time>
                                        </p>
                                    </div>
                                    <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                                        <p>
                                            Ważny do:
                                            {{ ' ' }}
                                            <time :datetime="position.expiresAt">{{ position.expiresAt }}</time>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <p class="text-center p-2 mb-10">Korzystanie z kodu rabatowego będzie możliwe po zaznaczeniu w koszyku opcji: <b>"Mam
        kupon rabatowy"</b>. <br>W pole tekstowe należy wkleić kod rabatowy i nacisnąć przycisk <b>"użyj".</b></p>

    <div class="flex justify-center my-16">
        <a href="https://uchowanca.pl/dostawaZeroFbEs" target="_blank">
            <button type="button"
                    class="inline-flex items-center rounded-full border border-transparent bg-red-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">
                Otwórz Supermarket Online
            </button>
        </a>
    </div>

    <!--    STATS-->
    <div class="bg-gray-900 py-24 sm:py-32">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <dl class="grid grid-cols-1 gap-y-16 gap-x-8 text-center lg:grid-cols-3">
                <div v-for="stat in stats" :key="stat.id" class="mx-auto flex max-w-xs flex-col gap-y-4">
                    <dt class="text-base leading-7 text-gray-400">{{ stat.name }}</dt>
                    <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-5xl">{{
                            stat.value
                        }}
                    </dd>
                </div>
            </dl>
        </div>
    </div>

    <div>
        <img class="w-screen" src="/img/delivery-footer.jpg" alt="delivery"/>
    </div>

</template>

<script>
import PageHeading from "../components/layout/PageHeading";


const stats = [
    {id: 1, name: 'Ekspresowa dostawa z zachowaniem ciągu chłodniczego', value: 'Dostawa'},
    {id: 2, name: 'Wykwalifikowany personel kompletujący zamówienia', value: 'Jakość'},
    {id: 3, name: 'Oferta ponad 15.000 produktów spożywczych i przemysłowych', value: 'Wybór'},
]

const positions = [
    {
        id: 1,
        title: 'W42dA',
        type: 'Aktywny',
        department: 'Bielsko-Biała',
        closeDate: '2020-01-07',
    },
    {
        id: 2,
        title: 'W42dA',
        type: 'Aktywny',
        department: 'Jaworze i Jasienica',
        closeDate: '2020-01-07',
    },
    {
        id: 3,
        title: 'W42dA',
        type: 'Aktywny',
        department: 'Wapienica',
        closeDate: '2020-01-14',
    },
]

export default {
    name: "DeliveryPage",
    components: {PageHeading},
    data: () => ({
        stats,
        positions,
    }),
    created() {
        this.getPromoCodes()
    },
    methods: {
        async getPromoCodes() {
            await fetch(`https://cloudpanel.pl/api/uchowanca/promoCodes`)
                .then(response => response.json())
                .then(result => {
                    this.positions = result.promoCodes;
                });
        },
        copyCode(value) {
            navigator.clipboard.writeText(value);
            this.emitter.emit('notification', {
                title: 'Kod ' + value + ' dodany do schowka!',
                message: 'Wklej kod w koszyku sklepu internetowego',
                type: 'success'
            })
        }
    }
}
</script>


<style scoped>

</style>
